var React = require('react');

function NavIconsUsage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3.46 20.62v-18.29h-1v19.34h19.13v-1.05zm2.91-1.62v-6.45h-1.06v6.45zm3.43 0v-9.91h-1.06v9.91zm3.43 0v-13.38h-1.06v13.38zm3.43 0v-6.45h-1.06v6.45zm3.43-11.57h-1.09v11.57h1.06z"}));
}

NavIconsUsage.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsUsage;

NavIconsUsage.default = NavIconsUsage;
